import { render, staticRenderFns } from "./SummaryListItems.vue?vue&type=template&id=6b345d4d"
import script from "./SummaryListItems.vue?vue&type=script&lang=js"
export * from "./SummaryListItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports